module.exports = "<park-schedule-form [formMode]=\"'create'\" [park]=\"park\"></park-schedule-form>\n\n<park-schedule-item *ngFor=\"let schedule of sortedSchedules\" [scheduleId]=\"schedule[0]\"\n                    [schedule]=\"schedule[1]\" [park]=\"park\"></park-schedule-item>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/parks/park/schedules/park-schedules.html
// module id = ./src/app/dashboard/parks/park/schedules/park-schedules.html
// module chunks = main